<template>
  <div>
    <el-form style="margin-left: 40px">
      <el-form-item label="预警类型：" :label-width="formInputWidth">
        <el-col :span="12">
          <el-select v-model="formData.alert_type" filterable placeholder="请选择" :disabled="idDisabled">
            <el-option v-for="item in earlyWarningOptions" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-col>
      </el-form-item>
      <el-form-item label="特殊类型：" :label-width="formInputWidth" v-if="specialShow">
        <el-col :span="12">
          <el-select v-model="formData.special_type" multiple :collapse-tags="viewShow" filterable placeholder="请选择" :disabled="idDisabled">
            <el-option v-for="item in specialTypeOptions" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-col>
      </el-form-item>

      <el-form-item label="时间间隔：" :label-width="formInputWidth">
        <el-col :span="6">
          <el-input v-model="formData.time_interval_value" onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')" :disabled="idDisabled"> </el-input>
        </el-col>
        <el-col :span="8">
          <el-radio v-model="formData.time_interval_type" label="1" :disabled="idDisabled">/分钟</el-radio>
          <el-radio v-model="formData.time_interval_type" label="2" :disabled="idDisabled">/小时</el-radio>
        </el-col>
      </el-form-item>
      <el-form-item :label="boundaryName" :label-width="formInputWidth">
        <el-col :span="8">
          <el-input v-model="formData.alert_value" placeholder="请输入" onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')" :disabled="idDisabled"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="监控范围：" :label-width="formInputWidth">
        <el-col :span="8">
          <el-time-picker
            is-range
            v-model="formData.timeRange"
            format="HH:mm"
            value-format="HH:mm"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            placeholder="选择时间范围"
            :disabled="idDisabled"
            @change="timeSelect"
          >
          </el-time-picker>
        </el-col>
      </el-form-item>

      <el-form-item label="预警通知人：" :label-width="formInputWidth">
        <el-col :span="16">
          <el-select v-model="formData.base_alert_admin" multiple filterable :collapse-tags="viewShow" placeholder="请选择" :disabled="idDisabled">
            <el-option v-for="item in noticePersonOptions" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-col>
      </el-form-item>
      <el-form-item label="通知形式：" :label-width="formInputWidth">
        <el-col :span="16">
          <el-checkbox-group v-model="formData.alert_method" :disabled="idDisabled">
            <el-checkbox label="弹窗"></el-checkbox>
            <el-checkbox label="飞书"></el-checkbox>
          </el-checkbox-group>
        </el-col>
      </el-form-item>
      <el-form-item label="是否开启电话通知：" :label-width="formInputWidth" v-if="dingShow">
        <el-col :span="8">
          <el-select v-model="formData.alert_by_phone" filterable placeholder="请选择" :disabled="idDisabled">
            <el-option v-for="item in phoneNoticeOptions" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-col>
      </el-form-item>
      <el-form-item label="电话通知人：" :label-width="formInputWidth" v-if="phoneShow">
        <el-col :span="16">
          <el-select v-model="formData.phone_alert_admin" multiple filterable :collapse-tags="viewShow" placeholder="请选择" :disabled="idDisabled">
            <el-option v-for="item in phoneNoticePersonOptions" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-col>
      </el-form-item>
      <el-form-item label="电话通知阈值：" :label-width="formInputWidth" v-if="phoneShow">
        <el-col :span="8">
          <el-input v-model="formData.phone_alert_value" onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')" placeholder="请输入" :disabled="idDisabled"></el-input>
        </el-col>
        <el-col :span="4">
          <span>分钟</span>
        </el-col>
      </el-form-item>
      <el-form-item label="开关" :label-width="formInputWidth">
        <el-col :span="8">
          <el-select v-model="formData.system_status" filterable placeholder="请选择" :disabled="idDisabled">
            <el-option v-for="item in switchOptions" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-col>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { matchAlertAdmin } from '@/api/early_warning';

export default {
  name: 'platformListForm',
  props: {
    formData: {
      type: Object,
    },
    earlyWarningOptions: {
      type: Array,
    },
    specialTypeOptions: {
      type: Array,
    },
    noticePersonOptions: {
      type: Array,
    },
    phoneNoticeOptions: {
      type: Array,
    },
    phoneNoticePersonOptions: {
      type: Array,
    },
    switchOptions: {
      type: Array,
    },
    boundaryName: {
      type: String,
    },
    idDisabled: {
      type: Boolean,
      default: false,
    },
    dingShow: {
      type: Boolean,
      default: false,
    },
    phoneShow: {
      type: Boolean,
      default: false,
    },
    viewShow: {
      type: Boolean,
      default: true,
    },
    specialShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formInputWidth: '200px',
    };
  },
  methods: {
    // 时间筛选预警通知人
    async timeSelect() {
      const r = await matchAlertAdmin({ begin_time: this.formData.timeRange[0], end_time: this.formData.timeRange[1] });
      const arr = r.data.data.admin_id_array.concat(this.formData.base_alert_admin);
      const adminSet = new Set(arr);
      this.formData.base_alert_admin = Array.from(adminSet);
    },
  },
};
</script>